import { EmploymentTypes } from "src/shared/config";

export const BASE_URL = "https://www.mathrix.ai/api/";
export const URL_PATH = "https://www.mathrix.ai";

export const endPoints: {
  [key in "careers" | "blogs" | "auth"]: string;
} = {
  careers: "career/",
  blogs: "blog/",
  auth: "auth/",
};

export const employmentLabels: Record<EmploymentTypes, string> = {
  [EmploymentTypes.CONTACT]: "Contact",
  [EmploymentTypes.FULL_TIME]: "Full time",
  [EmploymentTypes.REMOTE]: "Remote",
  [EmploymentTypes.HALF_TIME]: "Half time",
};
